import { fetch } from '@atlassian/eoc-fetch';

import type { GetConfiguredSyncsResponse } from '../../../common/mocks/configured-syncs/types';
import type { SyncPatchPayload } from '../../../common/types/configured-syncs';
import type { SyncValues } from '../../../common/types/sync';
import { UrlHelper } from '../../../common/utils/url-helper';
import type { ConfiguredSyncsResource } from '../resources/types';

import { LIMIT } from './constants';

const getSyncs = async (
	query: Record<string, string>,
	pathParamTeamId?: string | null,
): Promise<ConfiguredSyncsResource> => {
	const page = parseInt(query['page']) || 1;
	const offset = (page - 1) * LIMIT;
	const queryParams = query
		? {
				teamId: pathParamTeamId ?? query.teamId,
				type: query.type,
				keyword: query.keyword,
				status: query.status,
			}
		: {};

	return fetch<GetConfiguredSyncsResponse>(
		UrlHelper('/v1/entity-sync/unified', {
			...queryParams,
			offset: offset.toString(), // UrlHelper omits 0 as number since it is a falsy value
			limit: LIMIT,
		}),
	).then((response) => ({
		data: response.data.integrations,
		pageCount: Math.ceil(response.data.count / LIMIT),
		itemCount: response.data.count,
	}));
};

const patchSync = async (
	syncId: string,
	syncType: string,
	body: SyncPatchPayload,
	teamId?: string,
): Promise<SyncValues> =>
	fetch<{ data: SyncValues }>(
		UrlHelper(`/v1/entity-sync/unified/${syncId}`, {
			type: syncType,
			teamId,
		}),
		{
			method: 'PATCH',
			body,
		},
	).then((response) => response.data);

const deleteSync = async (syncId: string, syncType: string, teamId?: string): Promise<Response> =>
	fetch(
		UrlHelper(`/v1/entity-sync/unified/${syncId}`, {
			type: syncType,
			teamId,
		}),
		{
			method: 'DELETE',
			responseType: 'headers',
		},
	);

const _default_1: {
	deleteSync: (syncId: string, syncType: string, teamId?: string) => Promise<Response>;
	getSyncs: (
		query: Record<string, string>,
		pathParamTeamId?: string | null,
	) => Promise<ConfiguredSyncsResource>;
	patchSync: (
		syncId: string,
		syncType: string,
		body: SyncPatchPayload,
		teamId?: string,
	) => Promise<SyncValues>;
} = {
	getSyncs,
	patchSync,
	deleteSync,
};
export default _default_1;
